(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('SmsLimit', SmsLimit);

    SmsLimit.$inject = ['$resource', 'DateUtils'];

    function SmsLimit ($resource, DateUtils) {
        var resourceUrl =  'api/sms-limits/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
